import { createApp } from 'vue'
import App from './FormView.vue'
import router from './router'

createApp(App).use(router).mount('#app')
